import React, {useEffect, useState} from 'react';

const Zaslona = () => {
    const [hide, setHide] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setHide(true);
        }, 400);
    }, []);

    return (
        <div
        className={`fixed top-0 left-0 w-full h-full bg-[#061e3d] transition-all z-20 duration-700 ease-in-out
        transform ${hide ? ' -translate-y-full' : ''}`}>
            
        </div>
    );
}

export default Zaslona;
